import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "@mui/icons-material";
import { Button } from "reactstrap";
import AdminSidebar from "./AdminSidebar";
import "./AdminLayout.css";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div
        className={`admin-sidebar-wrapper ${
          sidebarOpen ? "open" : ""
        }`}
      >
        <AdminSidebar  closeSidebar={() => setSidebarOpen(false)} />
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Content */}
      <div className="admin-content">

        {/* Mobile Header */}
        <div className="mobile-header">
          <Button
            color="primary"
            size="sm"
            className="menu-btn"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu />
          </Button>

        </div>

        <div className="admin-main">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;